'use es6';

import { createAction } from 'flux-actions';
import { REMOVE_ATTACHMENT } from '../constants/fileUploadsActionTypes';
export const removeAttachment = createAction(REMOVE_ATTACHMENT, ({
  localId,
  threadId
}) => ({
  localId,
  threadId
}));